/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { RootStoreType } from './index'

/**
 * KeepUserSubscriptionResponseBase
 * auto generated base class for the model KeepUserSubscriptionResponseModel.
 */
export const KeepUserSubscriptionResponseModelBase = ModelBase.named('KeepUserSubscriptionResponse')
  .props({
    __typename: types.optional(types.literal('KeepUserSubscriptionResponse'), 'KeepUserSubscriptionResponse'),
    success: types.union(types.undefined, types.boolean)
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class KeepUserSubscriptionResponseModelSelector extends QueryBuilder {
  get success() {
    return this.__attr('success')
  }
}
export function selectFromKeepUserSubscriptionResponse() {
  return new KeepUserSubscriptionResponseModelSelector()
}

export const keepUserSubscriptionResponseModelPrimitives = selectFromKeepUserSubscriptionResponse().success
